module.exports = __webpack_public_path__ + "static/img/link2.2addaa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/links/link2.png
// module id = baUh
// module chunks = 12